import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import Icon from '../../Common/Icon';
import Notification from '../../Common/Notification';
import MentionableTextArea from '../../Common/MentionableTextArea/MentionableTextArea';
import { DATE_FORMAT } from '../../../constants/constants';
import * as types from '../../../constants/actionTypes';

export class CommentRow extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            comment: props.comment,
            isEditable: false,
            isEditing: false
        }
    }

    componentDidMount = () => {
        const isModifiedRecently = Moment.utc().diff(this.state.comment.created) < 1000 * 60 * 5; //5 minutes ago
        this.setState({ isEditable: isModifiedRecently });
    }

    onModifyCommentClick = () => {
        this.setState({ isEditing: true });
    }

    cancelModify = () => {
        this.setState({ isEditing: false });
    }

    onCommentChange = (e) => {
        this.setState({
            ...this.state,
            comment: {
                ...this.state.comment,
                comment: e.target.value
            }
        });
    }

    onModifyCommentSave = async () => {
        try {
            const response = await this.props.locationTaskActions.updateComment(this.state.comment.id, this.state.comment.comment);
            if (response.type === types.UPDATE_LOCATION_TASK_COMMENT_SUCCESS) {

                Notification("success", "Comment Updated", "");
                this.setState({
                    isEditing: false,
                    comment: {
                        ...this.state.comment,
                        commentHtml: response.payload.commentHtml
                    }
                });

            } else if (response.type === types.UPDATE_LOCATION_TASK_COMMENT_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    render() {
        return (
            <div className="list-group-item list-group-item-action flex-column align-items-start">

                {this.state.isEditing ?
                    <Fragment>
                        <MentionableTextArea
                            name="comment"
                            value={this.state.comment.comment}
                            onChange={this.onCommentChange}
                            data={this.props.mentionableUsers}
                            maxLength={2000}
                        />
                        <div className="text-center pb-2">
                            <button type="button" className="drawer-button btn btn-primary button--save" onClick={this.onModifyCommentSave}>Post</button>
                            <button type="button" className="drawer-button btn btn-primary button--save" onClick={this.cancelModify}>Cancel</button>
                        </div>
                    </Fragment>
                    :
                    <p className="mb-1">
                        {this.state.isEditable ?
                            <a href="#" onClick={this.onModifyCommentClick}>
                                <Icon name="pencil-alt" />
                            </a>
                            : null
                        }

                        <span className="comment-rendered text-break" dangerouslySetInnerHTML={{__html: this.state.comment.commentHtml}}></span>
                    </p>
                }
                <small className="d-flex">
                    {this.state.comment.createdBy} | {Moment.utc(this.state.comment.created).format(DATE_FORMAT)}
                </small>
                {Moment(this.state.comment.created).diff(this.state.comment.modified) < 0 ? //if created date is not the same as modified date
                    <small className="text-muted">
                        Edited by {this.state.comment.modifiedBy} | {Moment.utc(this.state.comment.modified).format(DATE_FORMAT)}
                    </small>
                    : null
                }
            </div>
        )
    }
}

CommentRow.propTypes = {
    comment: PropTypes.object.isRequired,
    locationTaskActions: PropTypes.object.isRequired,
    mentionableUsers: PropTypes.array.isRequired
};

export default CommentRow;
